import APIClient from '../../services/APIClient';
import { makeApiCall } from '../../services/ApiService';

export default {

    getTasksCollection: () => makeApiCall({
        startCallMessage: 'API: Fetching Tasks Data',
        successMessage: 'API: Successfully Fetched Tasks Data',
        failureMessage: 'API: Fetching Tasks Failed',
        url: '/admin/tasks/task-collection',
        method: APIClient.get,
        data: null,
        config: null,
        extractPath: (data) => data.tasksCollections,
    }),

    getTasks: (params: any) => makeApiCall({
        startCallMessage: 'API: Fetching Tasks Data',
        successMessage: 'API: Successfully Fetched Tasks Data',
        failureMessage: 'API: Fetching Tasks Failed',
        url: '/admin/tasks',
        params,
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.tasks,
    }),

    editTasks: (data: any) => {
        return makeApiCall({
            startCallMessage: 'API: Editing Tasks',
            successMessage: 'API: Editing Tasks Success',
            failureMessage: 'API: Editing Tasks Failed',
            data,
            url: '/admin/tasks' + (data._id ? `/${data._id}` : ''),
            method: APIClient.put,
            config: null,
            extractPath: (data) => data,
        })
    },

    deleteTasks: (data: any) => makeApiCall({
        startCallMessage: 'API: Deleting Tasks',
        successMessage: 'API: Deleting Tasks Success',
        failureMessage: 'API: Deleting Tasks Failed',
        data,
        url: '/admin/tasks/delete',
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

}
